'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'phase', 'phaseFilters', 'def',
    function ($scope, $modalInstance, phase, phaseFilters, def) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.isSelect = isSelect;

        init();

        // region Function

        function init() {
            // инициализация модели
            $scope.phase = angular.copy(phase);
            $scope.filters = angular.copy(phaseFilters);
            $scope.def = angular.copy(def);
        }

        function ok(phase) {
            $modalInstance.close(phase);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function isSelect() {
            return $scope.phase != null && $scope.phase.id != null;
        }

        // endregion
    }];
